// import React, { useEffect, useState } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import axios from "axios";

// const Gallery = () => {
//   const [galleryList, setGalleryList] = useState([]);
//   const [selectedImage, setSelectedImage] = useState(null);

//   useEffect(() => {
//     const fetchGallery = async () => {
//       try {
//         const response = await axios.get(
//           "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/gallery_list"
//         );

//         if (response.data.status === true) {
//           const baseUrl = "https://cyberathon.com/NLF/";


//           const formatted = response.data.data.map((item) => ({
//             heading: item.gallery_heading,
//             images: item.gallery_image.map((img) => baseUrl + img),
//           }));

//           setGalleryList(formatted);
//         }
//       } catch (error) {
//         console.error("Error fetching gallery:", error);
//       }
//     };

//     fetchGallery();
//   }, []);

//   const openImage = (src) => setSelectedImage(src);
//   const closeImage = () => setSelectedImage(null);

//   return (
//     <div className="container py-5" style={{ marginTop: "80px" }}>

//       {galleryList.map((gallery, gIndex) => (
//         <div key={gIndex}>

//           {/* SAME DESIGN */}
//           <h2 className="text-center mb-4 fw-bold">{gallery.heading}</h2>

//           <div className="row d-flex justify-content-center mb-5">
//             {gallery.images.map((img, index) => (
//               <div
//                 key={index}
//                 className="col-md-4 col-sm-6 col-12 mb-4"
//                 onClick={() => openImage(img)}
//                 style={{ cursor: "pointer" }}
//               >
//                 <img
//                   src={img}
//                   alt={`Gallery ${index}`}
//                   className="img-fluid shadow-sm"
//                   style={{
//                     height: "250px",
//                     width: "100%",
//                     objectFit: "cover",
//                     borderRadius: "5px",
//                   }}
//                 />
//               </div>
//             ))}
//           </div>
//         </div>
//       ))}

//       {/* SAME MODAL */}
//       {selectedImage && (
//         <div
//           className="image-modal"
//           onClick={closeImage}
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             width: "100%",
//             height: "100%",
//             backgroundColor: "rgba(0,0,0,0.8)",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             zIndex: 9999,
//           }}
//         >
//           <div
//             className="image-modal-content"
//             onClick={(e) => e.stopPropagation()}
//             style={{
//               maxWidth: "90%",
//               maxHeight: "90%",
//             }}
//           >
//             <img
//               src={selectedImage}
//               alt="Expanded View"
//               style={{
//                 width: "100%",
//                 height: "100%",
//                 objectFit: "contain",
//                 borderRadius: "5px",
//               }}
//             />
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Gallery;


// import React, { useEffect, useState } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import axios from "axios";

// const Gallery = () => {
//   const [galleryList, setGalleryList] = useState([]);
//   const [selectedImageIndex, setSelectedImageIndex] = useState(null);
//   const [carouselImages, setCarouselImages] = useState([]);

//   useEffect(() => {
//     const fetchGallery = async () => {
//       try {
//         const response = await axios.get(
//           "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/gallery_list"
//         );

//         if (response.data.status === true) {
//           const baseUrl = "https://cyberathon.com/NLF/";

//           const formatted = response.data.data.map((item) => ({
//             heading: item.gallery_heading,
//             images: item.gallery_image.map((img) => baseUrl + img),
//           }));

//           setGalleryList(formatted);
//         }
//       } catch (error) {
//         console.error("Error fetching gallery:", error);
//       }
//     };

//     fetchGallery();
//   }, []);

//   const openCarousel = (images, index) => {
//     setCarouselImages(images);
//     setSelectedImageIndex(index);
//   };

//   const closeCarousel = () => {
//     setSelectedImageIndex(null);
//     setCarouselImages([]);
//   };

//   const showNext = () => {
//     setSelectedImageIndex((prev) =>
//       prev + 1 < carouselImages.length ? prev + 1 : 0
//     );
//   };

//   const showPrev = () => {
//     setSelectedImageIndex((prev) =>
//       prev - 1 >= 0 ? prev - 1 : carouselImages.length - 1
//     );
//   };

//   return (
//     <div className="container py-5" style={{ marginTop: "80px" }}>
//       {galleryList.map((gallery, gIndex) => {
//         const visibleImages = gallery.images.slice(0, 7);
//         // const hasMoreImages = gallery.images.length > 7;

//         return (
//           <div key={gIndex}>
//             <h2 className="text-center mb-4 fw-bold">{gallery.heading}</h2>

//             {/* SHOW EXACTLY 7 IMAGES IN ONE GROUP (Bootstrap auto wraps 3 top + 4 bottom) */}
//             <div className="gallery-row mb-5">

//   {visibleImages.map((img, index) => (
//     <div
//       key={index}
//       className="glyimage"
//       onClick={() => openCarousel(gallery.images, index)}

//     >
//       <img src={img} alt="" style={{width:"100px"}} />
//     </div>
//   ))}

//   {/* SELECT MORE IMAGES BOX */}
//   {/* {hasMoreImages && (
//     <div
//       className="gallery-image-box d-flex justify-content-center align-items-center"
//       onClick={() => openCarousel(gallery.images, 0)}
//       style={{
//         border: "2px dashed #666",
//         fontSize: "20px",
//         fontWeight: "bold",
//         color: "#444",
//         borderRadius: "6px",
//       }}
//     >
//       + Select Images
//     </div>
//   )} */}

// </div>

//           </div>
//         );
//       })}

//       {/* CAROUSEL MODAL */}
//       {selectedImageIndex !== null && (
//         <div
//           onClick={closeCarousel}
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             width: "100%",
//             height: "100%",
//             background: "rgba(0,0,0,0.85)",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             zIndex: 9999,
//           }}
//         >
//           <div
//             onClick={(e) => e.stopPropagation()}
//             style={{ position: "relative", width: "90%", maxWidth: "900px" }}
//           >
//             <img
//               src={carouselImages[selectedImageIndex]}
//               alt=""
//               style={{
//                 width: "100%",
//                 maxHeight: "80vh",
//                 objectFit: "contain",
//                 borderRadius: "10px",
//               }}
//             />

//             {/* PREV BUTTON */}
//             <button
//               onClick={showPrev}
//               style={{
//                 position: "absolute",
//                 left: 0,
//                 top: "50%",
//                 transform: "translateY(-50%)",
//                 fontSize: "35px",
//                 background: "none",
//                 border: "none",
//                 color: "#fff",
//                 cursor: "pointer",
//               }}
//             >
//               ❮
//             </button>

//             {/* NEXT BUTTON */}
//             <button
//               onClick={showNext}
//               style={{
//                 position: "absolute",
//                 right: 0,
//                 top: "50%",
//                 transform: "translateY(-50%)",
//                 fontSize: "35px",
//                 background: "none",
//                 border: "none",
//                 color: "#fff",
//                 cursor: "pointer",
//               }}
//             >
//               ❯
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Gallery;

import SEO from "../Component/SEO";
import React, { useEffect, useState } from "react";
import axios from "axios";

const Gallery = () => {
  const [mainGalleryList, setMainGalleryList] = useState([]);
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  const [carouselImages, setCarouselImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [carouselLoading, setCarouselLoading] = useState(false);

  const BASE_URL = "https://cyberathon.com/NLF/";

  useEffect(() => {
    const fetchMainGallery = async () => {
      try {
        const response = await axios.get(
          "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/main_gallery_list"
        );

        if (response.data?.status) {
          const formatted = response.data.data.map((item) => ({
            id: item.main_gallery_id,
            heading: item.gallery_heading,
            image: BASE_URL + item.gallery_image[0], // First image as thumbnail
          }));
          setMainGalleryList(formatted);
        }
      } catch (error) {
        console.error("Main Gallery API Error:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchMainGallery();
  }, []);

  // 🔥 FETCH SUB GALLERY AND OPEN MODAL
  const openSubGallery = async (mainGalleryId, mainImage) => {
    setCarouselLoading(true);
    try {
      const formData = new FormData();
      formData.append("main_gallery_id", mainGalleryId);

      const response = await axios.post(
        "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/get_id_sub_gallery_image",
        formData
      );

      let images = [];

      if (response.data?.status && response.data.data?.length > 0) {
        images = response.data.data.flatMap((subGallery) =>
          subGallery.multi_image.map((img) => BASE_URL + img)
        );
      }

      // ✅ FALLBACK: if no sub images, use main image
      if (images.length === 0) {
        images = [mainImage];
      }

      setCarouselImages(images);
      setSelectedImageIndex(0);
    } catch (error) {
      console.error("Sub Gallery API Error:", error);

      // ✅ Even if API fails, still show main image
      setCarouselImages([mainImage]);
      setSelectedImageIndex(0);
    } finally {
      setCarouselLoading(false);
    }
  };


  // 🔥 CLOSE MODAL
  const closeCarousel = () => {
    setSelectedImageIndex(null);
    setCarouselImages([]);
  };

  // 🔥 NEXT IMAGE
  const showNext = () => {
    setSelectedImageIndex((prev) =>
      prev + 1 < carouselImages.length ? prev + 1 : 0
    );
  };

  // 🔥 PREVIOUS IMAGE
  const showPrev = () => {
    setSelectedImageIndex((prev) =>
      prev - 1 >= 0 ? prev - 1 : carouselImages.length - 1
    );
  };

  return (
    <>
      <SEO
        title="Architectural Projects & Solutions Gallery | NLF Solutions"
        description="Explore NLF Solutions' completed architectural projects featuring metal ceilings, facades, roofing, furniture and acoustic solutions across India."
        canonical="https://nlfs.in/gallery"
        keywords="Architectural Project Gallery, NLF projects, Architectural projects, Completed projects, Facade projects, Interior projects, Ceiling projects, Project portfolio, architectural projects in India, architectural project gallery, commercial architectural projects, completed architectural projects"
      />
      <h1 className="seo-h1">Our Architectural Projects</h1>

      <div className="container py-4" style={{ marginTop: "115px" }}>
        {loading ? (
          <p className="text-center">Loading...</p>
        ) : (
          <div className="mb-5">
            <h4 className="text-center mb-3">Our Gallery</h4>

            <div className="row g-4 justify-content-center">
              {mainGalleryList.map((gallery, index) => (
                <div
                  className="col-lg-3 col-md-4 col-sm-6 text-center"
                  key={index}
                >
                  <div
                    className="gallery-card"
                    onClick={() => openSubGallery(gallery.id, gallery.image)}
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      src={gallery.image}
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                  <h5>{gallery.heading}</h5>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* 🔥 MODAL CAROUSEL */}
        {selectedImageIndex !== null && (
          <div
            onClick={closeCarousel}
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.85)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            {carouselLoading ? (
              <p style={{ color: "#fff" }}>Loading images...</p>
            ) : (
              <div
                onClick={(e) => e.stopPropagation()}
                style={{
                  position: "relative",
                  width: "90%",
                  maxWidth: "900px",
                  textAlign: "center"
                }}
              >
                <img
                  src={carouselImages[selectedImageIndex]}
                  alt=""
                  style={{
                    width: "90%",
                    maxHeight: "80vh",
                    objectFit: "contain",
                    borderRadius: "10px",
                  }}
                />

                {/* PREV */}
                <button
                  onClick={showPrev}
                  style={{
                    position: "absolute",
                    left: 0,
                    top: "50%",
                    transform: "translateY(-50%)",
                    fontSize: "35px",
                    background: "none",
                    border: "none",
                    color: "#fff",
                    cursor: "pointer",
                  }}
                >
                  ❮
                </button>

                {/* NEXT */}
                <button
                  onClick={showNext}
                  style={{
                    position: "absolute",
                    right: 0,
                    top: "50%",
                    transform: "translateY(-50%)",
                    fontSize: "35px",
                    background: "none",
                    border: "none",
                    color: "#fff",
                    cursor: "pointer",
                  }}
                >
                  ❯
                </button>

                {/* IMAGE COUNTER */}
                <div
                  style={{
                    position: "absolute",
                    bottom: "20px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    color: "#fff",
                    background: "rgba(0,0,0,0.6)",
                    padding: "5px 15px",
                    borderRadius: "20px",
                  }}
                >
                  {selectedImageIndex + 1} / {carouselImages.length}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default Gallery;